import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "cbfb80bf-b3d6-4634-b85c-c89eeec53cae",
  publicId: "15",
  name: "Binaural Recording & Measurement",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
